import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/membershipplans`;
const subResource = `/api/v1/subscriptionplans`;
const payResource = `/api/v1/onlinepayments`;
const gateResource = `/api/v1/gateways`;
export default {
  getMemebershipPlantsAvailability(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/availability`, {
      baseURL,
      headers,
      params,
    });
  },
  postData(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getMembershipPlanById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  secondaryPostData(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/complete`, body, {
      baseURL,
      headers,
      params,
    });
  },
  postOnlinePaymentReq(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${payResource}/request`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getSubscriptionPlans(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${subResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getActiveSubscriptionPlans(baseURL = {}, headers = {}, params = {}) {
    
    return BaseRepository.get(`${resource}/active`, {
      baseURL,
      headers,
      params,
    });
  },
  getData(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/bymerchant`, {
      baseURL,
      headers,
      params,
    });
  },
  deleteData(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getGateways(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${gateResource}`, {
      baseURL,
      headers,
      params,
    });
  },
    autoCreateBaseMemershipPlan(body, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`,body, {
      baseURL,
      headers,
      params,
    });
  }
};
